module.exports = __webpack_public_path__ + "img/ro.552b5d97.svg";